module.exports = __webpack_public_path__ + "static/media/30.8fa709a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/30.jpg
// module id = 399
// module chunks = 0